/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2023
 * @flow
 */

import React from 'react';
import cn from 'classnames';
import FireboardUtils from '../../util/fireboard-util';
import useStyles from './useStyles';
import { Box, Typography } from '@material-ui/core';

const StandardSms = ({ sms, storeInfo, onHandleSend, selectedItem, iso2, smsIndex }) => {
  const classes = useStyles();
  const [selectedAction, setSelectedAction] = React.useState(-1);

  const getSourceTypeFromOrderType = (type) => {
    switch (type) {
      case 5:
        return "curbside";
      case 6:
        return "online";
      case 8:
        return "call in";
      case 7:
        return "walkup";
      default:
        break;
    }
  };

  const dataObj = {
    address: selectedItem.checkInNote,
    phone: FireboardUtils.formattedPhoneNumber(storeInfo.phoneNumber, iso2),
    "pickup time": FireboardUtils.getTimeInHrsMins(selectedItem.pickupDate),
    location: storeInfo.name,
    "order type": getSourceTypeFromOrderType(selectedItem.sourceType),
    "slotName": selectedItem?.slotName,
  };

  let formatMessage = sms;
  Object.keys(dataObj).forEach((key) => {
    if (key === "address") {
      if (
        formatMessage.includes(
          "Your order from [location] is now on its way to"
        )
      ) {
        const address = dataObj[key] || "";
        const replaceableText = !!address ? `[${key}]` : `to [${key}]`;
        formatMessage = formatMessage.replace(replaceableText, address);
      } else {
        formatMessage = formatMessage.replace(
          `[${key}]`,
          dataObj[key] || "your address"
        );
      }
    } else if (key === 'slotName' && dataObj[key]) {
      formatMessage = formatMessage.replace(`[${key}]`, ` in cubby slot ${dataObj[key]}`);
    } else {
      formatMessage = formatMessage.replace(`[${key}]`, dataObj[key] || "");
    }
  });

  return (
    <Box mt={1} mb={1} display={'flex'} alignItems={'center'}
      className={cn(classes.smsRow, { [classes.highlightedRow]: selectedAction === smsIndex })}
      onMouseEnter={() => setSelectedAction(smsIndex)}
      onMouseLeave={() => setSelectedAction(-1)}
      onClick={() => onHandleSend(formatMessage, {})}
    >
      <Typography variant='body2' className={classes.rowContent}>{formatMessage}</Typography>
    </Box>
  );
};

export default StandardSms;
